import request from '../../utils/request';

const FacturiScadenteService = {
  dashboard: () => {
    return request('/facturiScadente/dashboard', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  importInvoices: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return request(
      '/facturiScadente/import/invoices',
      {
        method: 'POST',
        body: formData,
      },
      true,
    );
  },
  importCompanies: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return request(
      '/facturiScadente/import/companies',
      {
        method: 'POST',
        body: formData,
      },
      true,
    );
  },
  searchCompanies: (search: any) => {
    return request('/facturiScadente/companies/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  getClients: (params: any) => {
    const query = new URLSearchParams();
    if (params?.search) {
      query.append('search', params.search);
    }
    if (params?.category) {
      query.append('category', params.category);
    }
    if (params?.missingEmailOnly) {
      query.append('missingEmailOnly', 'true');
    }
    if (params?.withEmailOnly) {
      query.append('withEmailOnly', 'true');
    }
    if (params?.needsInfoOnly) {
      query.append('needsInfoOnly', 'true');
    }
    if (params?.hasOutstandingOnly) {
      query.append('hasOutstandingOnly', 'true');
    }
    if (params?.notificationsEnabledOnly) {
      query.append('notificationsEnabledOnly', 'true');
    }
    if (params?.skip !== undefined) {
      query.append('skip', String(params.skip));
    }
    if (params?.take !== undefined) {
      query.append('take', String(params.take));
    }
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return request(`/facturiScadente/clients${suffix}`, {
      method: 'GET',
    });
  },
  getClientSummary: (params: any) => {
    const query = new URLSearchParams();
    if (params?.search) {
      query.append('search', params.search);
    }
    if (params?.category) {
      query.append('category', params.category);
    }
    if (params?.missingEmailOnly) {
      query.append('missingEmailOnly', 'true');
    }
    if (params?.withEmailOnly) {
      query.append('withEmailOnly', 'true');
    }
    if (params?.needsInfoOnly) {
      query.append('needsInfoOnly', 'true');
    }
    if (params?.hasOutstandingOnly) {
      query.append('hasOutstandingOnly', 'true');
    }
    if (params?.notificationsEnabledOnly) {
      query.append('notificationsEnabledOnly', 'true');
    }
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return request(`/facturiScadente/clients/summary${suffix}`, {
      method: 'GET',
    });
  },
  updateCompany: (update: any) => {
    return request('/facturiScadente/companies/update', {
      method: 'POST',
      body: JSON.stringify({ request: { ...update } }),
    });
  },
  patchClient: (id: string, update: any) => {
    return request(`/facturiScadente/clients/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ ...update }),
    });
  },
  bulkPatchClients: (payload: any) => {
    return request('/facturiScadente/clients/bulk', {
      method: 'PATCH',
      body: JSON.stringify({ ...payload }),
    });
  },
  searchInvoices: (search: any) => {
    return request('/facturiScadente/invoices/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  groupedInvoices: (search: any) => {
    return request('/facturiScadente/invoices/grouped', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  failedEmails: (take: number = 20) => {
    return request('/facturiScadente/emailLogs/failed', {
      method: 'POST',
      body: JSON.stringify({ request: { take } }),
    });
  },
  latestImport: () => {
    return request('/facturiScadente/imports/latest', {
      method: 'GET',
    });
  },
  approveLatestImport: () => {
    return request('/facturiScadente/imports/approve', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  runNotifications: () => {
    return request('/facturiScadente/notifications/run', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  runNotificationsForClient: (id: string) => {
    return request(`/facturiScadente/notifications/run/client/${id}`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  runNotificationsForClients: (clientIds: string[]) => {
    return request('/facturiScadente/notifications/run/clients', {
      method: 'POST',
      body: JSON.stringify({ clientIds }),
    });
  },
  previewNotificationForClient: (id: string, scheduledContext: boolean = false) => {
    const query = new URLSearchParams();
    if (scheduledContext) {
      query.append('scheduledContext', 'true');
    }
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return request(`/facturiScadente/notifications/preview/client/${id}${suffix}`, {
      method: 'GET',
    });
  },
  previewNotificationPdfForClient: (id: string, scheduledContext: boolean = false) => {
    const query = new URLSearchParams();
    if (scheduledContext) {
      query.append('scheduledContext', 'true');
    }
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return request(
      `/facturiScadente/notifications/preview/client/${id}/pdf${suffix}`,
      {
        method: 'GET',
      },
      true,
    );
  },
  notificationStatus: () => {
    return request('/facturiScadente/notifications/status', {
      method: 'GET',
    });
  },
  notificationPreflight: () => {
    return request('/facturiScadente/notifications/preflight', {
      method: 'GET',
    });
  },
  getNotificationCategories: () => {
    return request('/facturiScadente/notifications/categories', {
      method: 'GET',
    });
  },
  updateNotificationCategories: (categories: { category: string; isEnabled: boolean }[]) => {
    return request('/facturiScadente/notifications/categories', {
      method: 'PUT',
      body: JSON.stringify({ categories }),
    });
  },
  patchInvoiceNotification: (
    id: string,
    payload: {
      isNotificationEnabled?: boolean;
    },
  ) => {
    return request(`/facturiScadente/invoices/${id}/notification`, {
      method: 'PATCH',
      body: JSON.stringify({ ...payload }),
    });
  },
  updateNotificationConfig: (payload: any) => {
    return request('/facturiScadente/notifications/config', {
      method: 'PUT',
      body: JSON.stringify({ ...payload }),
    });
  },
  scheduleStatus: () => {
    return request('/facturiScadente/schedule', {
      method: 'GET',
    });
  },
  notificationHistory: (search: any) => {
    return request('/facturiScadente/notifications/history', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
};

export default FacturiScadenteService;
